export var IconSize;
(function (IconSize) {
    IconSize["s"] = "s";
    IconSize["m"] = "m";
    IconSize["l"] = "l";
    IconSize["xl"] = "xl";
})(IconSize || (IconSize = {}));
export var Variant;
(function (Variant) {
    Variant["light"] = "light";
    Variant["dark"] = "dark";
    Variant["gradient"] = "gradient";
    Variant["lightGradient"] = "lightGradient";
    Variant["modern"] = "modern";
})(Variant || (Variant = {}));
